import {httpRequest} from '../../@crema/services/auth/jwt-auth';

const schedulerApi = {
  // Get scheduler status
  getStatus: async () => {
    try {
      const response = await httpRequest('scheduler/status', {method: 'GET'});
      return response.data;
    } catch (error) {
      console.error('Error fetching scheduler status:', error);
      throw error;
    }
  },

  // Start scheduler
  start: async () => {
    try {
      const response = await httpRequest('scheduler/start', {method: 'POST'});
      return response.data;
    } catch (error) {
      console.error('Error starting scheduler:', error);
      throw error;
    }
  },

  // Stop scheduler
  stop: async () => {
    try {
      const response = await httpRequest('scheduler/stop', {method: 'POST'});
      return response.data;
    } catch (error) {
      console.error('Error stopping scheduler:', error);
      throw error;
    }
  },

  // Toggle scheduler
  toggle: async () => {
    try {
      const response = await httpRequest('scheduler/toggle', {method: 'POST'});
      return response.data;
    } catch (error) {
      console.error('Error toggling scheduler:', error);
      throw error;
    }
  },

  // Health check
  health: async () => {
    try {
      const response = await httpRequest('scheduler/health', {method: 'GET'});
      return response.data;
    } catch (error) {
      console.error('Error checking scheduler health:', error);
      throw error;
    }
  },
};

export default schedulerApi;
